const HTTP_STATUSES = {
  ACCEPTED: 'ACCEPTED',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  BAD_REQUEST: 'ERR_BAD_REQUEST',
};

const HTTP_STATUSE_CODES = {
  OK: 200,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
};

export { HTTP_STATUSES, HTTP_STATUSE_CODES };
